import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { UiModule } from '../../../ui/ui.module';
import { LabelPreviewHostComponent } from './label-preview-host.component';
import { EtikettPreviewModalComponent } from './etikett-preview-modal.component';

@NgModule({
  declarations: [
    LabelPreviewHostComponent,
    EtikettPreviewModalComponent,
  ],
  exports: [
    LabelPreviewHostComponent,
    EtikettPreviewModalComponent,
  ],
  imports: [
    CommonModule,
    NzEmptyModule,
    NzSpinModule,
    UiModule,
  ],
})
export class EtikettenPreviewModule {}
